import { apiClient } from "@/services/api-client";

export const getMainMenuApi = () => {
  return apiClient({
    url: `/v1/main-menus`,
    method: "GET",
  });
};
